import { gql } from '@apollo/client';

const CREATE_UNREVIEWED_REPORT = gql`
  mutation createUnreviewedReport($input: CreateUnreviewedReportInput!) {
    createUnreviewedReport(input: $input) {
      isSuccess
      message
      existedReport {
        id
        status
        isArtifactReport
      }
    }
  }
`;

export default CREATE_UNREVIEWED_REPORT;
